import React from 'react';
import {
  Container, Box, Paper, Typography, Divider, Link,
} from '@mui/material';

export default function BeforeUse() {
  return (
    <Container
      component="main"
      maxWidth="md"
      sx={{
        marginTop: 8,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
      }}
    >
      <Paper elevation={15} style={{ padding: '30px' }}>
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
          }}
          mb={2}
        >
          <Typography mb={2} component="h1" variant="h5">
            ご利用前の確認事項
          </Typography>
        </Box>
        <Box>本アプリを快適にご利用いただくため、以下の環境を推奨しております。</Box>
        <Box>推奨環境以外でのご利用、または推奨環境であってもお客さまのブラウザ設定や通信環境によっては、正常に動作しない場合がございます。あらかじめご了承ください。</Box>

        <Box mt={2}>■対応ブラウザ</Box>
        <Box>Google Chrome 最新版</Box>
        <Box>Microsoft Edge 最新版</Box>
        <Box>Safari 最新版（macOS / iOS）</Box>
        <Box>Mozilla Firefox 最新版</Box>
        <Box>※ Internet Explorer には対応しておりません。</Box>
        <Box mt={2}>■推奨OS</Box>
        <Box>Windows 11 以降</Box>
        <Box>macOS 13（Ventura）以降</Box>
        <Box>iOS 17 以降</Box>
        <Box>Android 13 以降</Box>
        <Box mt={2}>■ご利用にあたっての注意事項</Box>
        <Box>本アプリでは JavaScript を使用しています。ご利用の際はブラウザの設定で JavaScript を有効にしてください。</Box>
        <Box>Cookie を利用する機能が含まれます。無効化している場合、一部機能が正しく動作しない可能性があります。</Box>
        <Box>スマートフォン・タブレットをご利用の場合は、標準ブラウザ（iOS Safari / Android Chrome）でのご利用を推奨いたします。</Box>
        <Divider />
        <Box mt={2}>
          <Typography variant="body2" color="text.secondary" align="center">
            {'Copyright © '}
            <Link color="inherit" href="https://www.cqree.jp/corporate/" target="_blank">
              Cqree INC.
            </Link>
            {' '}
            {new Date().getFullYear()}
            .
          </Typography>
        </Box>
      </Paper>
    </Container>
  );
}
